import type { Dispatch } from '@reduxjs/toolkit'

import { appActions } from '@appStore/reducers/app'
import { automationApi } from 'api/automationApi'
import { helpersFunc } from 'config/helpers'
import { appConnector } from 'shared/connector'

import type { Profile } from './types'

import { apiRTK } from '../api-rtk'

function resetCache(dispatch: Dispatch) {
	dispatch(
		appActions.setAppProfile({
			appProfile: {},
			appProfileDone: false
		})
	)

	dispatch(apiRTK.util.resetApiState())
	dispatch(automationApi.util.resetApiState())
}

const createSimpleWrapper = (fetchFn: () => Promise<any>) => async () => {
	try {
		const data = await fetchFn()
		return { data }
	} catch (error) {
		return { error }
	}
}

export const connectorApi = apiRTK.injectEndpoints({
	endpoints: create => ({
		captureLinkedIn: create.mutation<Profile, void>({
			queryFn: createSimpleWrapper(appConnector.linkedIn.captureCurrentProfile)
		}),

		getSnailyProfile: create.query<any, void>({
			async queryFn() {
				try {
					const data = await appConnector.auth.getSnailyProfile()
					console.log(`profile: ${data}`)
					return { data }
				} catch (error) {
					helpersFunc.logEnjectServicePromise(error)
					//#88 introduce FatalError and throw it here instead of generic Error with Message FATAL ERROR
					// throw new FatalError(
					// 	`Unhandled exception occurs during getting ${CONSTS.PROJECT_NAME} profile`
					// )

					return { error }
				}
			}
		}),
		signInUnderTeamMember: create.mutation<boolean, string>({
			async queryFn(id, { dispatch }) {
				const signIn = appConnector.auth.signInUnderTeamMember

				try {
					await signIn(id)
					console.log('signed')
					resetCache(dispatch)
					return { data: true }
				} catch (error) {
					return { error }
				}
			}
		}),

		signOut: create.mutation<boolean, void>({
			async queryFn() {
				const signOut = appConnector.auth.signOut

				try {
					await signOut()
					return { data: true }
				} catch (error) {
					return { error }
				}
			}
		}),

		stopMemberSession: create.mutation<boolean, void>({
			async queryFn(_, { dispatch }) {
				const signOut = appConnector.auth.signOutUnderTeamMember

				try {
					await signOut()
					resetCache(dispatch)
					return { data: true }
				} catch (error) {
					return { error }
				}
			}
		})
	}),
	overrideExisting: true
})
